// LanguageSelect.tsx
"use client";
import React from "react";
import styles from "./LanguageSelect.module.css"; // optional CSS module

import { useLanguage } from "@/providers/LanguageContext";

export function LanguageSelect() {
 const {language, setLanguage} = useLanguage();

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(e.target.value as "es" | "en");
  };

  return (
    <div className={styles.languageSelectWrapper}>
      {/* You can also add a label or placeholder text here */}
      <select
        className={styles.customSelect}
        value={language}
        onChange={handleSelect}
      >
        <option value="es">🇵🇪 Esp</option>
        <option value="en">🇺🇸 En</option>
      </select>
    </div>
  );
}
